module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_c('b', [_vm._v("Contents")])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', [_c('li', [_c('a', {
    attrs: {
      "hidden": "hidden",
      "href": "#/text/nav"
    }
  }, [_c('span', {
    staticClass: "hide1"
  }, [_vm._v("Contents")])])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3.5em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_1#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 The Game")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3.5em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 A Glimmer of Understanding")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3.5em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 A Mind Has Wings?")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3.5em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Before We Continue")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3.5em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Can He . . . or Will He?")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "2.9em",
      "text-indent": "0em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rpre"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Preface#pre",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3.5em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Thinking Beyond What Is True")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3.5em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Imagining a Sense of Humor")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "2.5em",
      "text-indent": "-2.2em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch7a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7a#ch7a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 "), _c('sup', [_vm._v("1")]), _vm._v("/2 And While We’re on the Subject . . .")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3.5em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Isn’t It Obvious?")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3.5em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Well . . . "), _c('i', [_vm._v("That")]), _vm._v(" Changes Everything")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Imagining Beyond Imagination")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Secret Benchmark")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Your Special Place")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 "), _c('i', [_vm._v("Beyond")]), _vm._v(" the Box. Please!")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 How Could I Have Missed It?")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 A Salty Detail")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Discovering the Truth About Myself")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "2.5em",
      "text-indent": "-2.2em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch16a"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_16a#ch16a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16"), _c('sup', [_vm._v("1")]), _vm._v("/2 Not Even A Full Turn")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 The OGV and Your Future")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Competing in Deep Water")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 The Invisible, Uncontestable Edge")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Money in Garbage")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 A Smart Man . . . and a Wise One")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3em",
      "text-indent": "-1.4em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Connecting the Dots")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "0.2em",
      "padding-left": "3em",
      "text-indent": "-1.3em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "rch23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Reaching the Promised Land")])]), _vm._v(" "), _c('li', {
    staticClass: "toc",
    staticStyle: {
      "margin-top": "1em",
      "padding-left": "0em",
      "text-indent": "0em"
    },
    attrs: {
      "epub:type": "chapter",
      "id": "raut"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#aut",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hide1"
  }, [_c('nav', {
    attrs: {
      "epub:type": "landmarks",
      "hidden": ""
    }
  }, [_c('h1', [_vm._v("Guide")]), _vm._v(" "), _c('ol', [_c('li', [_c('span', {
    attrs: {
      "epub:type": "cover",
      "href": "#/text/9780785226543_Cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/text/nav"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/text/9780785226543_Chapter_1#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 The Game")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hide1"
  }, [_c('nav', {
    attrs: {
      "epub:type": "page-list",
      "hidden": "hidden",
      "xmlns:epub": "http://www.idpf.org/2007/ops"
    }
  }, [_c('ol', [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Praise#page_i",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("i")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Praise#page_ii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ii")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Praise#page_iii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("iii")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Titlepage#page_v",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("v")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Copyright#page_vi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("vi")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Dedication#page_vii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("vii")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Dedication#page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("viii")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_1#page_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_1#page_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_1#page_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_1#page_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_1#page_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_1#page_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_2#page_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_2#page_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_2#page_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_2#page_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_3#page_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_3#page_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_3#page_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_3#page_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_3#page_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_3#page_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_4#page_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_4#page_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_4#page_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_4#page_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_4#page_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_4#page_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_5#page_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_5#page_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_5#page_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_5#page_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_5#page_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_5#page_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_5#page_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_5#page_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_6#page_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_6#page_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_6#page_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_6#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_6#page_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7#page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7#page_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7#page_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7#page_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7#page_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7#page_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7#page_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7#page_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7#page_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7a#page_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7a#page_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7a#page_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_7a#page_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_8#page_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_8#page_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_8#page_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_8#page_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_8#page_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_8#page_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_8#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_8#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_9#page_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_9#page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_9#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_9#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_10#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_10#page_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_10#page_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_10#page_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_10#page_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_10#page_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_10#page_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_10#page_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_11#page_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_11#page_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_11#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_11#page_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_12#page_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_12#page_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_12#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_12#page_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_13#page_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_13#page_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_13#page_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_13#page_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_13#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_13#page_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_13#page_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_13#page_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_14#page_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_14#page_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_14#page_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_14#page_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_15#page_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_15#page_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_15#page_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_15#page_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_15#page_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_15#page_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_16#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_16#page_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_16#page_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_16#page_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_16#page_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_16#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_16#page_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_16#page_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_16a#page_109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_16a#page_110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_16a#page_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_16a#page_112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_17#page_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_17#page_114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_17#page_115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_17#page_116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_17#page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_17#page_118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_17#page_119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_17#page_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_18#page_121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_18#page_122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_18#page_123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_18#page_124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_18#page_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_18#page_126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_18#page_127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_18#page_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_18#page_129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_18#page_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_19#page_148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_20#page_149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_20#page_150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_20#page_151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_20#page_152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_21#page_153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_21#page_154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_21#page_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_21#page_156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_21#page_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_21#page_158",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_22#page_159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_22#page_160",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_22#page_161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_22#page_162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_22#page_163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_22#page_164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_22#page_165",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_22#page_166",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_22#page_167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_22#page_168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_23#page_169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_23#page_170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_23#page_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_23#page_172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_23#page_173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_23#page_174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_23#page_175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Chapter_23#page_176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#page_177",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#page_178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("178")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Backad#page_179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("179")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Backad#page_180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Backad#page_181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("181")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/text/9780785226543_Backad#page_182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-336caf47","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/nav.vue
// module id = 72
// module chunks = 0